<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="supplies_list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="buttons"
            infiniteLoad="true"
            :addButton="{ permission: 'supplies:create' }"
            :updateButton="{ permission: 'supplies:update' }"
            @printbar="printbar"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="runCarteServer">同步</el-button>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import printJs from 'print-js'
export default {
    name: `DicSupplies`,
    props: {

    },
    data() {
        return {
            title: `耗材维护`,
            url: {
                baseURL: `/api/AcisSystem/Supplies`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadSupplies(resolve, reject)
                    })
                }
            },
            buttons: [{
                class: `is-plain`,
                label: `打印条码`,
                type: `primary`,
                emit: `printbar`,
                permission: `default`
            }],
            applytype: this.$route.query.applytype,
            suppliesCategory: []
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            var applytypes = this.sys_enums.Enum_ApplyType || []
            if (this.applytype == 1) {
                applytypes = _.filter(applytypes, r => { return r.value != 2 })
            } else if (this.applytype == 2) {
                applytypes = _.filter(applytypes, r => { return r.value != 1 })
            }
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `select`,
                prop: `dic_supplies_category_id`,
                label: `耗材分类`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: this.suppliesCategory,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `apply_type`,
                label: `耗材类型`,
                width: `100`,
                isListable: !this.applytype,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: applytypes,
                default: this.applytype || 0
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `string`,
                prop: `alias`,
                label: `别名`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                //   type: "bool",
                //   prop: "is_into_counting",
                //   label: "纳入清点",
                //   width: "180",
                //   isListable: true,
                //   isExpand: false,
                //   isEditable: true,
                //   isCreatable: true,
                //   searchable: true,
                //   options:'enum_bool',
                //   default:false
                // }, {
                type: `string`,
                prop: `spec`,
                label: `规格`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: false
            }, {
                type: `number`,
                prop: `price`,
                label: `价格`,
                width: `180`,
                isListable: false,
                isEditable: true,
                isCreatable: true,
                searchable: false
            }, {
                type: `string`,
                prop: `pkg_unit`,
                label: `计价单位`,
                width: `180`,
                isListable: false,
                isEditable: true,
                isCreatable: true,
                searchable: false
            }, {
                type: `string`,
                prop: `firm`,
                label: `厂家`,
                width: `180`,
                isListable: false,
                isEditable: true,
                isCreatable: true,
                searchable: false
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `string`,
                prop: `barcode`,
                label: `条码号`,
                colspan: 12,
                isListable: false,
                isEditable: true,
                isCreatable: true
            }, {
                type: `bool`,
                prop: `is_fixed`,
                label: `固定耗材`,
                colspan: 12,
                width: `70`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                readonly: false,
                options: `enum_bool`,
                default: false
            }]
        }
    },
    created() {
        this.loadSuppliesCategory()
    },
    methods: {
        loadSuppliesCategory() {
            let req = this.myaxios.get(`/api/AcisSystem/SuppliesCategory/Get`)
            req.then(data => {
                this.suppliesCategory = _.map(data, d => {
                    return {
                        label: d.name,
                        value: d.id,
                        disabled: d.is_deleted
                    }
                })
            })
        },
        runCarteServer() {
            let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_dic_supply&paramStr=1`)
            req.then(data => {
                this.$refs[`supplies_list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        loadSupplies(resolve, reject) {
            // 加载可用模板
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Supplies/GetByApplyType?applytype=${that.applytype}`)
            req.then(data => {
                resolve(data)
            }).catch(e => reject(e))
        },
        printbar({ row }) {
            let req = this.myaxios.get(`/api/AcisSystem/Supplies/CreateSupplieBarcode/${row.id}`)
            req.then(data => {
                printJs({ printable: `data:image/jpeg;base64,` + data, type: `image`, base64: true, maxWidth: 1500 })
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Supplies/Supply.vue